import API from "shared/services/Api";
import {
  ICities,
  INeighborhood,
  IRegions,
  IStates,
  IStreet,
  IUrgency,
} from "shared/types";

export const getStates = async (insurance: number): Promise<IStates> =>
  API.get(`/address/states?insurance=${insurance}`);

export const getRegions = async (state: string): Promise<IRegions> =>
  API.get(`address/regions?city=${state}`);

export const getCities = async (
  state: string,
  insurance: number
): Promise<ICities> =>
  API.get(`address/cities?state=${state}&insurance=${insurance}`);

export const getNeighborhoods = async (
  state: string,
  city: string,
  insurance: number,
  region?: string
): Promise<INeighborhood> =>
  API.get(
    `address/neighborhood?state=${state}&insurance=${insurance}&city=${city}${
      region && `&region=${region}`
    }`
  );

export const getStreet = async (
  city: string,
  neigh: string
): Promise<IStreet> =>
  API.get(`address/neighborhood/street?city=${city}&neighborhood=${neigh}`);

export const getEmergency = async (id: number): Promise<IUrgency> =>
  API.get(`address/emergency?id=${id}`);
